import * as S from "@dcspark/cardano-multiplatform-lib-nodejs";
import { addressToBech32, getCborHexToWasm, JsToWasm, utxoWasmToJs, wasmToCborHex, wasmToJs, } from "@sundae/serialization";
export class Cip30ConnectedWallet {
    constructor(connectedApi) {
        this.getNetworkId = () => {
            return this.connectedApi.getNetworkId();
        };
        this.getUtxos = (amount, paginate) => {
            return this.connectedApi
                .getUtxos(amount ? wasmToCborHex(JsToWasm.Value(amount)) : undefined, paginate)
                .then((utxos) => utxos.map(this.deserialize.utxo).map(utxoWasmToJs));
        };
        this.getCollateral = (amount) => {
            const getCollateralRef = this.connectedApi?.getCollateral
                ? this.connectedApi.getCollateral
                : this.connectedApi.experimental
                    ?.getCollateral;
            if (!getCollateralRef) {
                throw new Error("Could not find reference to getCollateral");
            }
            return getCollateralRef({ amount }).then((utxos) => utxos.map(this.deserialize.utxo).map(utxoWasmToJs));
        };
        this.connectedApi = connectedApi;
        this.deserialize = {
            utxo: getCborHexToWasm(S.TransactionUnspentOutput),
            value: getCborHexToWasm(S.Value),
        };
    }
    getBalance() {
        return this.connectedApi
            .getBalance()
            .then((v) => wasmToJs(this.deserialize.value(v)));
    }
    getUsedAddresses(paginate) {
        return this.connectedApi
            .getUsedAddresses(paginate)
            .then((addresses) => addresses.map(addressToBech32));
    }
    getUnusedAddresses(paginate) {
        return this.connectedApi
            .getUnusedAddresses(paginate)
            .then((addresses) => addresses.map(addressToBech32));
    }
    getChangeAddress() {
        return this.connectedApi.getChangeAddress().then(addressToBech32);
    }
    getRewardAddresses() {
        return this.connectedApi
            .getRewardAddresses()
            .then((addresses) => addresses.map(addressToBech32));
    }
    signData(addr, payload) {
        return this.connectedApi.signData(addr, payload);
    }
    signTx(tx, partialSign) {
        return this.connectedApi.signTx(tx, partialSign);
    }
    submitTx(tx) {
        return this.connectedApi.submitTx(tx);
    }
}
//# sourceMappingURL=Cip30ConnectedWallet.js.map